<template>
  <v-avatar
    v-if="type"
    class="grey lighten-4"
    size="small"
    @click="$emit('click', $event)"
  >
    <ReportIcon :type="type" :icons="icons" />
  </v-avatar>
</template>

<script>
import ReportIcon from "./ReportIcon.vue";

export default {
  name: "ReportIconAvatar",
  components: { ReportIcon },
  props: ["type", "icons"],
};
</script>
